import * as React from 'react'

import { Plus } from 'lucide-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'

import { useResourcePickerContext } from '../ResourcePickerContext'

const PickerCreateButton: React.FC = () => {
  const { startCreating } = useResourcePickerContext()

  return (
    <Button
      variant="ghost"
      size="icon"
      className="tw:shrink-0 tw:grow-0! tw:rounded-full"
      onClick={startCreating}
      aria-label="Create new"
    >
      <Plus />
    </Button>
  )
}

export default PickerCreateButton
